import { o as e } from "./object-keys-internal.js";
import { e as o } from "./enum-bug-keys.js";
var r = Object.keys || function (r) {
  return e(r, o);
};
export { r as o };